export default __webpack_public_path__ + "static/media/Emily-Boitein.42e9cea7.jpg";